import WithWebSockets from './withWebSockets'

export default WithWebSockets
